module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rCIDsC/tc-custom/9781439672082.jpg?1705201909923",
      "alt": "This image is the cover for the book Denville 13"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Denville 13\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Denville in the 1950s was an idyllic place to live, yet a dark chapter in the era's history has remained uncovered. During the summer of 1953, a wealthy traveler with a secret rap sheet as a convicted sex offender arrived in town to continue his misdeeds. A group of thirteen local boys ranging in age from fourteen to twenty-two took it upon themselves to teach the man a lesson and drive him out of town. What resulted was his brutal death and the largest number of people ever indicted for murder in the nation at the time. The harrowing trial and its aftermath revealed a town forced to grapple with how to protect its youth and come to terms with the gruesome incident. Local historian Peter Zablocki covers the crime and a small town's path to redemption.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Peter Zablocki\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Peter Zablocki is an author, researcher and teacher living in Denville, New Jersey. Focusing on local history, he is the author of Denville Goes to War: Denville's Story of World War I and is an AP seminar and research teacher with over fifteen years of teaching experience. Peter serves as the vice-president of the Denville Historical Society and Museum and is one of Denville's town historians.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0